import { makeStyles } from '@material-ui/core';
import { purple } from 'globals/colors';

export const useStyles = makeStyles(({ palette, spacing }) => ({
  paper: {
    background: purple.V2,
    color: palette.common.white,
    padding: spacing(3, 1, 1),
    '& h4': {
      paddingLeft: spacing(2),
    },
  },
}));
